module.exports = __webpack_public_path__ + "static/img/3-2.9dafbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/3-2.jpg
// module id = TiDn
// module chunks = 0